import { JSX, ParentProps, createMemo } from "solid-js";
import { Flexbox, Icon } from "st-app";
import { StaffRole, roleDashboard as api } from 'sis-app/api'
import { requireRoleDashboardContext } from "../RoleDashboardContext";
import styles from '../sis-role-dashboard.module.css'

type GroupProps = { title: string, icon: string, color?: string; style?: string; };
export function Group(props: ParentProps<GroupProps>) {
    const ctx = requireRoleDashboardContext();
    const headerStyle = createMemo(() => {
        const res: JSX.CSSProperties = {};

        if (props.color) {
            if (props.color.startsWith('--')) {
                res["background-color"] = `var(${props.color})`;
            }
            else {
                res["background-color"] = props.color;
            }
        }

        return res;
    });

    return <Flexbox class={styles.group} dir='vertical' wrap data-staff-role={StaffRole[ctx.selectedRole()]} style={props.style ?? ''} >
        <Flexbox as="h2" dir="horizontal" middle style={headerStyle()} >
            <Flexbox.Item as="span">{props.title}</Flexbox.Item>
        </Flexbox>
        <Flexbox dir="horizontal" wrap>
            {props.children}
        </Flexbox>
    </Flexbox>
}
